import React from 'react';

 
const PromoItem = (props) => {

    return (
        
        <div className="col-md-4 col-sm-12"> 
            <div className="single_promo_box" style={{backgroundImage: `url(${require('../../assets/images/' + props.bgImg)})`}} >
                <i className={`${props.icon}`}></i> 
               
                    <h4>{props.title}</h4>
            
                <div className="hover">
                    <p>{props.text} </p>
                </div>
            </div>
        </div>  

    );
}

export default PromoItem;